import { md } from '@/utils/utils_html';

interface Props {
  children?: React.ReactNode;
}

export const TopbarInfoWrapper = ({ children }: Props) => {
  return (
    <div
      className={`
                  flex items-center
                  w-full min-h-8 h-8
                  border-b border-component-border  text-page-foreground  text-sm 
                  ${md('text-center justify-center bg-component', 'text-left bg-bar')}
                `}
    >
      {children}
    </div>
  );
};
